// extracted by mini-css-extract-plugin
export default {"Page":"IndexPage_Page__fctfX","PageContainer":"IndexPage_PageContainer__PPQdE","PageActions":"IndexPage_PageActions__ksH9G"};